import { combineReducers } from 'redux';
import shop from './shop';
import tips from './tips';

const rootReducer = combineReducers({
    shop,
    tips
});

export default rootReducer;